import { FC, useState } from 'react'

export interface ISelectOption {
    label: string
    value: string | number
    [key: string]: any
}

export const Select: FC<{
    options: ISelectOption[]
    state: [ISelectOption | undefined, (option: ISelectOption) => void]
    title?: string
    unknownValue?: string
    preset?: 'select' | 'select-text'
}> = ({ options, state, title, unknownValue, preset }) => {
    const [show, setShow] = useState(false)
    const [st, setSt] = state
    const selectedPreset = preset ? preset : 'select'

    function selecting(option: ISelectOption) {
        setShow(false)
        setSt(option)
    }

    return (
        <div className={selectedPreset}>
            {title ? (
                <div className={`${selectedPreset}__title`}>{title}</div>
            ) : null}
            <div
                className={`${selectedPreset}__body`}
                onClick={() => setShow(!show)}
            >
                <div className={`${selectedPreset}__field`}>
                    {st?.label || unknownValue}
                </div>
                <div
                    className={`${selectedPreset}__options ${
                        show ? `${selectedPreset}__options--show` : ''
                    }`}
                >
                    {options.map((option) => (
                        <div
                            className={`${selectedPreset}__option ${
                                option.value === st?.value
                                    ? `${selectedPreset}__option-active`
                                    : ''
                            }`}
                            onClick={() => selecting(option)}
                            key={option.value}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
